import { FaJs, FaPython, FaTerminal } from "react-icons/fa";

export const requestLanguages = [
  {
    index: 0,
    name: "Shell",
    icon: <FaTerminal />,
    languageOptions: {
      GetIpData: [
        {
          name: "cURL",
          content: (
            <pre>
              curl --location --request GET \ <br />
              'https://ipscore.app/apiv2/check-ip/{"{"}IP-ADDRESS{"}"}'
              <br />\ --header 'Authorization: Bearer YOUR_API_KEY'
            </pre>
          ),
        },
        {
          name: "PowerShell",
          content: (
            <pre>
              $headers = @{"{"} <br />
              ("Authorization" = "Bearer YOUR_API_KEY) <br />
              {"}"} <br />
              $response = Invoke-RestMethod -Uri <br />
              'https://ipscore.app/apiv2/check-ip/{"{"}IP-ADDRESS{"}"}' <br />
              -Method 'GET' -Headers $headers <br /> $response | ConvertTo-Json
            </pre>
          ),
        },
      ],
      GetBalance: [
        {
          name: "cURL",
          content: (
            <pre>
              curl --location --request GET
              'https://ipscore.app/apiv2/get_balance' \ <br />
              --header 'Authorization: Bearer YOUR_API_KEY'
            </pre>
          ),
        },
        {
          name: "Powershell",
          content: (
            <pre>
              $headers = @{"{"} <br />
              'Authorization' = 'Bearer YOUR_API_KEY' <br />
              {"}"} <br />
              <br />
              $response = Invoke-RestMethod -Uri
              'https://ipscore.app/apiv2/get_balance' -Method 'GET' -Headers
              $headers <br />
              $response | ConvertTo-Json
            </pre>
          ),
        },
      ],
      GetRequestsLeft: [
        {
          name: "cURL",
          content: (
            <pre>
              curl --location --request GET
              'https://ipscore.app/apiv2/get_ipchecker_requests' \ <br />
              --header 'Authorization: Bearer YOUR_API_KEY'
            </pre>
          ),
        },
        {
          name: "Powershell",
          content: (
            <pre>
              $headers = @{"{"} <br />
              'Authorization' = 'Bearer YOUR_API_KEY' <br />
              {"}"} <br />
              <br />
              $response = Invoke-RestMethod -Uri
              'https://ipscore.app/apiv2/get_ipchecker_requests' -Method 'GET' -Headers
              $headers <br /> $response | ConvertTo-Json <br />
            </pre>
          ),
        },
      ],
      GetSubscriptions: [
        {
          name: "cURL",
          content: (
            <pre>
              curl --location --request GET
              'https://ipscore.app/apiv2/get_ipchecker_subscription' \ <br />
              --header 'Authorization: Bearer YOUR_API_KEY'
            </pre>
          ),
        },
        {
          name: "Powershell",
          content: (
            <pre>
              $headers = @{"{"} <br />
              'Authorization' = 'Bearer YOUR_API_KEY' <br />
              {"}"} <br />
              $response = Invoke-RestMethod -Uri
              'https://ipscore.app/apiv2/get_ipchecker_subscription' -Method 'GET' -Headers
              $headers <br />
              $response | ConvertTo-Json
            </pre>
          ),
        },
      ],
    },
  },
  {
    index: 1,
    name: "JavaScript",
    icon: <FaJs />,
    languageOptions: {
      GetIpData: [
        {
          name: "Fetch",
          content: (
            <pre>
              var requestOptions = {"{"} <br />
              method: 'GET', <br />
              headers: {"{"} <br />
              'Authorization': 'Bearer YOUR_API_KEY' <br />
              {"}"}, <br />
              {"}"}; <br />
              <br />
              fetch("https://ipscore.app/apiv2/check-ip/{"{"}IP-ADDRESS{"}"}",{" "}
              requestOptions).then(response =&gt; response.text()) <br />
              .then(result =&gt; console.log(result)).catch(error =&gt;{" "}
              console.log('error', error)); <br />
            </pre>
          ),
        },
        {
          name: "Axios",
          content: (
            <pre>
              var axios = require('axios'); <br />
              <br />
              var config = {"{"} <br />
              method: 'get', <br />
              url: 'https://ipscore.app/apiv2/check-ip/{"{"}IP-ADDRESS{"}"}',{" "}
              <br />
              headers: {"{"} <br />
              'Authorization': 'Bearer YOUR_API_KEY' <br />
              {"}"} <br />
              {"}"}; <br />
              <br />
              axios(config)
              <br />
              .then(function(response){"{"} <br />
              console.log(JSON.stringify(response.data)); <br />
              {"}"}) .catch(function(error) {"{"} <br />
              console.log(error); <br />
              {"}"});
            </pre>
          ),
        },
        {
          name: "JQuery",
          content: (
            <pre>
              var settings = {"{"} <br />
              "url": "https://ipscore.app/apiv2/check-ip/{"{"}IP-ADDRESS{"}"}",{" "}
              <br />
              "method": "GET", <br />
              "timeout": 0, <br />
              "headers": {"{"} <br />
              "Authorization": "Bearer YOUR_API_KEY"
              <br />
              {"}"}
              <br />
              {"}"}; <br />
              $.ajax(settings).done(function(response) {"{"} <br />
              console.log(response); <br />
              {"}"});
            </pre>
          ),
        },
        {
          name: "XHR",
          content: (
            <pre>
              var xhr = new XMLHttpRequest(); <br />
              xhr.withCredentials = true; <br />
              <br />
              xhr.addEventListener("readystatechange", function() {"{"} <br />
              if (this.readyState === 4) {"{"} <br />
              console.log(this.responseText); <br />
              {"}"} <br />
              {"}"}); <br />
              <br />
              xhr.open("GET", "https://ipscore.app/apiv2/check-ip/{"{"}IP-ADDRESS
              {"}"}"); <br />
              xhr.setRequestHeader("Authorization", "Bearer YOUR_API_KEY");{" "}
              <br />
              <br />
              xhr.send();
            </pre>
          ),
        },
      ],
      GetBalance: [
        {
          name: "Fetch",
          content: (
            <pre>
              var requestOptions = {"{"} <br />
              method: 'GET', <br />
              headers: {"{"} <br />
              'Authorization': 'Bearer YOUR_API_KEY' <br />
              {"}"}, <br />
              {"}"}; <br />
              <br />
              fetch("https://ipscore.app/apiv2/get_balance", requestOptions){" "}
              <br />
              .then(response =&gt; response.text()) <br />
              .then(result =&gt; console.log(result)) <br />
              .catch(error =&gt; console.log('error', error));
            </pre>
          ),
        },
        {
          name: "Axios",
          content: (
            <pre>
              var axios = require('axios');
              <br />
              var config = {"{"} <br />
              method: 'get', <br />
              url: 'https://ipscore.app/apiv2/get_balance', <br />
              headers: {"{"} <br />
              'Authorization': 'Bearer YOUR_API_KEY' <br />
              {"}"} <br />
              {"}"}; <br />
              <br />
              axios(config) <br />
              .then(function(response) {"{"} <br />
              console.log(JSON.stringify(response.data)); <br />
              {"}"}) <br />
              .catch(function(error) {"{"} <br />
              console.log(error); <br />
              {"}"}); <br />
            </pre>
          ),
        },
        {
          name: "JQuery",
          content: (
            <pre>
              var settings = {"{"} <br />
              "url": "https://ipscore.app/apiv2/get_balance", <br />
              "method": "GET", <br />
              "timeout": 0, <br />
              "headers": {"{"} <br />
              "Authorization": "Bearer YOUR_API_KEY" <br />
              {"}"} <br />
              {"}"}; <br />
              <br />
              $.ajax(settings).done(function(response) {"{"} <br />
              console.log(response); <br />
              {"}"}); <br />
            </pre>
          ),
        },
        {
          name: "XHR",
          content: (
            <pre>
              var xhr = new XMLHttpRequest(); <br />
              xhr.withCredentials = true; <br />
              <br />
              xhr.addEventListener("readystatechange", function () {"{"} <br />
              if (this.readyState === 4) {"{"} <br />
              console.log(this.responseText); <br />
              {"}"} <br />
              {"}"}); <br />
              <br />
              xhr.open("GET", "https://ipscore.app/apiv2/get_balance"); <br />
              xhr.setRequestHeader("Authorization", "Bearer YOUR_API_KEY"); //
              Replace with your actual API key <br />
              xhr.send(); <br />
            </pre>
          ),
        },
      ],
      GetRequestsLeft: [
        {
          name: "Fetch",
          content: (
            <pre>
              var requestOptions = {"{"} <br />
              method: 'GET', <br />
              headers: {"{"} <br />
              'Authorization': 'Bearer YOUR_API_KEY' <br />
              {"}"}, <br />
              {"}"}; <br />
              <br />
              fetch("https://ipscore.app/apiv2/get_ipchecker_requests", requestOptions){" "}
              <br />
              .then(response =&gt; response.text()) <br />
              .then(result =&gt; console.log(result)) <br />
              .catch(error =&gt; console.log('error', error)); <br />
            </pre>
          ),
        },
        {
          name: "Axios",
          content: (
            <pre>
              var axios = require('axios'); <br />
              <br />
              var config = {"{"} <br />
              method: 'get', <br />
              url: 'https://ipscore.app/apiv2/get_ipchecker_requests', <br />
              headers: {"{"} <br />
              'Authorization': 'Bearer YOUR_API_KEY' <br />
              {"}"} <br />
              {"}"}; <br />
              <br />
              axios(config) <br />
              .then(function (response) {"{"} <br />
              console.log(JSON.stringify(response.data)); <br />
              {"}"}) <br />
              .catch(function (error) {"{"} <br />
              console.log(error);
              <br />
              {"}"}); <br />
            </pre>
          ),
        },
        {
          name: "JQuery",
          content: (
            <pre>
              var settings = {"{"} <br />
              "url": "https://ipscore.app/apiv2/get_ipchecker_requests", <br />
              "method": "GET", <br />
              "timeout": 0, <br />
              "headers": {"{"} <br />
              "Authorization": "Bearer YOUR_API_KEY"
              <br />
              {"}"} <br />
              {"}"}; <br />
              <br />
              $.ajax(settings).done(function(response) {"{"} <br />
              console.log(response); <br />
              {"}"}); <br />
            </pre>
          ),
        },
        {
          name: "XHR",
          content: (
            <pre>
              var xhr = new XMLHttpRequest(); <br />
              xhr.withCredentials = true; <br />
              <br />
              xhr.addEventListener("readystatechange", function () {"{"} <br />
              if (this.readyState === 4) {"{"} <br />
              console.log(this.responseText); <br />
              {"}"} <br />
              {"}"}); <br />
              <br />
              xhr.open("GET", "https://ipscore.app/apiv2/get_ipchecker_requests"); <br />
              xhr.setRequestHeader("Authorization", "Bearer YOUR_API_KEY"); //
              Replace with your actual API key <br />
              xhr.send(); <br />
            </pre>
          ),
        },
      ],
      GetSubscriptions: [
        {
          name: "Fetch",
          content: (
            <pre>
              var requestOptions = {"{"} <br />
              method: 'GET', <br />
              headers: {"{"} <br />
              'Authorization': 'Bearer YOUR_API_KEY'
              <br />
              {"}"}, <br />
              {"}"}; <br />
              <br />
              fetch("https://ipscore.app/apiv2/get_ipchecker_subscription", requestOptions){" "}
              <br />
              .then(response =&gt; response.text()) <br />
              .then(result =&gt; console.log(result)) <br />
              .catch(error =&gt; console.log('error', error)); <br />
              <br />
            </pre>
          ),
        },
        {
          name: "Axios",
          content: (
            <pre>
              var axios = require('axios'); <br />
              <br />
              var config = {"{"}
              method: 'get', <br />
              url: 'https://ipscore.app/apiv2/get_ipchecker_subscription', <br />
              headers: {"{"} <br />
              'Authorization': 'Bearer YOUR_API_KEY' <br />
              {"}"} <br />
              {"}"}; <br />
              <br />
              axios(config) <br />
              .then(function (response) {"{"} <br />
              console.log(JSON.stringify(response.data)); <br />
              {"}"}) <br />
              .catch(function (error) {"{"} <br />
              console.log(error); <br />
              {"}"}); <br />
            </pre>
          ),
        },
        {
          name: "JQuery",
          content: (
            <pre>
              var settings = {"{"} <br />
              "url": "https://ipscore.app/apiv2/get_ipchecker_subscription", <br />
              "method": "GET", <br />
              "timeout": 0, <br />
              "headers": {"{"} <br />
              "Authorization": "Bearer YOUR_API_KEY" <br />
              {"}"} <br />
              {"}"}; <br />
              <br />
              $.ajax(settings).done(function(response) {"{"} <br />
              console.log(response); <br />
              {"}"}); <br />
            </pre>
          ),
        },
        {
          name: "XHR",
          content: (
            <pre>
              var xhr = new XMLHttpRequest(); <br />
              xhr.withCredentials = true; <br />
              <br />
              xhr.addEventListener("readystatechange", function() {"{"} <br />
              if (this.readyState === 4) {"{"} <br />
              console.log(this.responseText); <br />
              {"}"} <br />
              {"}"}); <br />
              <br />
              xhr.open("GET", "https://ipscore.app/apiv2/get_ipchecker_subscription");{" "}
              <br />
              xhr.setRequestHeader("Authorization", "Bearer YOUR_API_KEY"); //
              Replace with your actual API key <br />
              xhr.send();
            </pre>
          ),
        },
      ],
    },
  },
  {
    index: 6,
    name: "Python",
    icon: <FaPython />,
    languageOptions: {
      GetIpData: [
        {
          name: "http.client",
          content: (
            <pre>
              import http.client <br />
              conn = http.client.HTTPSConnection("ipscore.app")
              <br />
              <br />
              payload = '' <br />
              <br />
              conn.request("GET", "/apiv2/check-ip/{"{"}IP-ADDRESS{"}"}",
              payload) <br />
              res = conn.getresponse() data = res.read()
              print(data.decode("utf-8"))
            </pre>
          ),
        },
        {
          name: "Requests",
          content: (
            <pre>
              import requests <br /> <br />
              url = "https://ipscore.app/apiv2/check-ip/{"{"}IP-ADDRESS{"}"}"{" "}
              <br />
              payload = {"{"}
              {"}"} <br />
              <br />
              response = requests.request("GET", url, data=payload) <br />
              print(response.text)
            </pre>
          ),
        },
      ],
      GetBalance: [
        {
          name: "http.client",
          content: (
            <pre>
              import http.client
              <br />
              conn = http.client.HTTPSConnection("ipscore.app") <br />
              headers = {"{"}'Authorization': 'Bearer YOUR_API_KEY'{"}"} #
              Replace with your actual API key <br />
              payload = '' <br />
              <br />
              conn.request("GET", "/apiv2/get_balance", payload, headers) <br />
              res = conn.getresponse() <br /> <br />
              data = res.read() <br /> <br />
              print(data.decode("utf-8")) <br />
            </pre>
          ),
        },
        {
          name: "Requests",
          content: (
            <pre>
              import requests
              <br />
              url = "https://ipscore.app/apiv2/get_balance"
              <br />
              # Replace 'YOUR_API_KEY' with your actual API key
              <br />
              headers = {"{"} <br />
              'Authorization': 'Bearer YOUR_API_KEY' <br />
              {"}"} <br />
              <br />
              response = requests.get(url, headers=headers)
              <br />
              print(response.text)
            </pre>
          ),
        },
      ],
      GetRequestsLeft: [
        {
          name: "http.client",
          content: (
            <pre>
              import http.client
              <br />
              conn = http.client.HTTPSConnection("ipscore.app")
              <br />
              headers = {"{"}'Authorization': 'Bearer YOUR_API_KEY'{"}"} #
              Replace with your actual API key
              <br />
              payload = ''
              <br />
              conn.request("GET", "/apiv2/get_ipchecker_requests", payload, headers){" "}
              <br />
              res = conn.getresponse() <br />
              data = res.read() <br />
              print(data.decode("utf-8")) <br />
            </pre>
          ),
        },
        {
          name: "Requests",
          content: (
            <pre>
              import requests
              <br />
              url = "https://ipscore.app/apiv2/get_ipchecker_requests"
              <br />
              # Replace 'YOUR_API_KEY' with your actual API key
              <br />
              headers = {"{"} <br />
              'Authorization': 'Bearer YOUR_API_KEY' <br />
              {"}"}
              <br />
              response = requests.get(url, headers=headers)
              <br />
              print(response.text)
            </pre>
          ),
        },
      ],
      GetSubscriptions: [
        {
          name: "http.client",
          content: (
            <pre>
              import http.client
              <br />
              conn = http.client.HTTPSConnection("ipscore.app")
              <br />
              headers = {"{"}'Authorization': 'Bearer YOUR_API_KEY'{"}"} #
              Replace with your actual API key
              <br />
              payload = ''
              <br />
              conn.request("GET", "/apiv2/get_ipchecker_subscription", payload, headers){" "}
              <br />
              <br />
              res = conn.getresponse() <br />
              data = res.read() <br />
              print(data.decode("utf-8")) <br />
            </pre>
          ),
        },
        {
          name: "Requests",
          content: (
            <pre>
              import requests
              <br />
              url = "https://ipscore.app/apiv2/get_ipchecker_subscription"
              <br />
              <br />
              # Replace 'YOUR_API_KEY' with your actual API key
              <br />
              headers = {"{"} <br />
              'Authorization': 'Bearer YOUR_API_KEY' <br />
              {"}"} <br />
              <br />
              response = requests.get(url, headers=headers)
              <br />
              print(response.text)
            </pre>
          ),
        },
      ],
    },
  },
];
